// components/RequireDev.jsx
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { db } from "../firebase/config";
import { doc, getDoc } from "firebase/firestore";

export default function RequireDev({ children }) {
  const { user, loading } = useAuth();
  const [allowed, setAllowed] = useState(null); // null = checking

  useEffect(() => {
    if (loading) return; // 🔴 wait for auth to be ready
    if (!user?.uid) {
      // no user after loading → not signed in
      setAllowed(false);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        // dev allowlist doc id must be EXACTLY the auth uid
        const snap = await getDoc(doc(db, "devUsers", user.uid));
        if (!cancelled) setAllowed(snap.exists());
      } catch (e) {
        console.error("RequireDev check failed:", e);
        if (!cancelled) setAllowed(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loading, user?.uid]); // 🔑 run only after loading flips to false

  if (loading || allowed === null) {
    return <div style={{ padding: 24 }}>Checking access…</div>;
  }

  if (!user?.uid) return <Navigate to="/login" replace />;
  if (!allowed) return <div style={{ padding: 24 }}>403 — Devs only.</div>;

  return children;
}
